import { create } from 'zustand'
import { Utente, login as apiLogin, logout as apiLogout, register as apiRegister, getProfile } from '../services/auth.service'
import { isAuthenticated } from '../services/api'

interface AuthState {
  utente: Utente | null
  loading: boolean
  error: string | null

  // Azioni
  login: (email: string, password: string) => Promise<void>
  register: (data: { email: string; password: string; nome: string; cognome?: string }) => Promise<void>
  logout: () => Promise<void>
  checkAuth: () => Promise<void>
  clearError: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  utente: null,
  loading: false,
  error: null,

  login: async (email, password) => {
    set({ loading: true, error: null })
    try {
      const utente = await apiLogin(email, password)
      set({ utente, loading: false })
    } catch (err: any) {
      set({ error: err.message, loading: false })
      throw err
    }
  },

  register: async (data) => {
    set({ loading: true, error: null })
    try {
      const utente = await apiRegister(data)
      set({ utente, loading: false })
    } catch (err: any) {
      set({ error: err.message, loading: false })
      throw err
    }
  },

  logout: async () => {
    await apiLogout()
    set({ utente: null })
  },

  checkAuth: async () => {
    if (!isAuthenticated()) {
      set({ utente: null })
      return
    }
    set({ loading: true })
    try {
      const utente = await getProfile()
      set({ utente, loading: false })
    } catch {
      set({ utente: null, loading: false })
    }
  },

  clearError: () => set({ error: null }),
}))
